<template>
    <div ref="asideScroller" class="h-full overflow-auto w-full">
        <div
            class="p-6 sticky top-0 bg-gray-tier-3 z-10 border-b border-keyline-primary"
            :class="{ 'shadow-lg': isScrolled }"
        >
            <SeclockMultiselect
                v-if="settings.is_sourcing_mode"
                class="w-full mb-2"
                :option-is-object="true"
                label-by="display_name"
                track-by="display_name"
                value-by="display_name"
                v-model="selectedManufacturer"
                :options="manufacturers"
                :searchable="true"
                :placeholder="$t('Choose a manufacturer')"
                :can-clear="false"
                mode="single"
                :large="false"
                @change="navigateToShow($event)"
            />

            <SearchInput v-model="searchTermProxy" :medium="true" />
        </div>

        <div class="type-secondary p-6 pb-0">
            {{ $t("Recent Catalogs") }}
        </div>

        <CatalogList class="p-6" :resources="newCatalogs" />
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { SeclockMultiselect, SearchInput, CatalogList } from '@/Components';
import { router } from '@inertiajs/vue3';
import route from 'ziggy-js';
import useUser from '@/Composables/Modules/useUser';

const { settings } = useUser();

const props = defineProps({
    manufacturers: {
        type: Array,
        required: true,
    },
    newCatalogs: {
        type: Array,
        required: true,
    },
    modelValue: {
        type: String,
        default: '',
    },
});

const emit = defineEmits(['update:modelValue']);

const selectedManufacturer = ref(null);

const searchTermProxy = computed({
    get() {
        return props.modelValue;
    },
    set(value) {
        emit('update:modelValue', value);
    },
});

// Scroll shadow handling for sticky header
const asideScroller = ref(null);
const isScrolled = ref(false);

const handleScroll = () => {
    isScrolled.value = (asideScroller.value?.scrollTop ?? 0) > 0;
};

onMounted(() => {
    asideScroller.value?.addEventListener('scroll', handleScroll);
    handleScroll();
});

onUnmounted(() => {
    asideScroller.value?.removeEventListener('scroll', handleScroll);
});

const navigateToShow = (event) => router.visit(route('web.catalog.resources.show', event.slug));
</script> 